<app-header></app-header>
<div class="container relative btm-img-pad">
  <div class="inner-content-wrap">
    <div class="thankyou-cnr">
      <!-- Form heading start -->
      <div class="common-head tk-promo mb44 mb28-700">
        @if (isExisitngUser === 'true') {
          <div>
            <h1 class="farro-header mb8">{{thankYouContentPage.thanksExisting}}</h1>
          </div>
        }
        @if (isExisitngUser === 'false') {
          <div>
            <h1 class="farro-header mb8">{{thankYouContentPage.thanks}}</h1>
          </div>
        }
        <p class="mb44 mb28-700">{{thankYouContentPage.thanksMessage}}</p>
        <div class="done-btn-cnr">
          <button id="done" class="done-btn" (click)="doneButton()">{{thankYouContentPage.done}}</button>
        </div>
      </div>
      <!-- Form heading end -->
      <div class="app-promo-bnr mb44 mb28-700">
        <div class="app-promo-bnr-img">
          <img src="./assets/img/wir-app-image.png" alt="IDP live App" width="186" height="238">
        </div>
        <div class="app-promo-bnr-txt">
          <h2 class="farro-header">{{thankYouContentPage.appDescription}}</h2>
          <p>{{thankYouContentPage.appSubHeading}}</p>
          <div class="app-promo-bnr-list flex flex-column justify-center items-start">
            <div class="app-promo-bnr-item flex items-center"><img src="./assets/icons/wir-clipboard-list.svg" alt="Clipboard icon"><span>{{thankYouContentPage.courseInformation}}</span></div>
            <div class="app-promo-bnr-item flex items-center"><img src="./assets/icons/wir-badge-check.svg" alt="Badge icon"><span>{{thankYouContentPage.recommendations}}</span></div>
            <div class="app-promo-bnr-item flex items-center"><img src="./assets/icons/wir-user.svg" alt="User icon"><span>{{thankYouContentPage.advice}}</span></div>
            <div class="app-promo-bnr-item flex items-center"><img src="./assets/icons/wir-document-search.svg" alt="Document icon"><span>{{thankYouContentPage.trackApplication}}</span></div>
          </div>
        </div>
      </div>
      <div class="app-promo-wrap flex flex-column justify-center items-center">
        <div class="app-promo-qr-img">
          <div class="app-promo-qr-img1">
            <a (click)="openGooglePlayApp()" class="cursor-pointer"><img src="../../../assets/icons/wir-google-play-qr.svg" alt="Google play QR Code for downloading IDP live APP" width="160"
            height="161"></a>
            <a (click)="openGooglePlayApp()" class="cursor-pointer"><img src="../../../assets/icons/wir-google-play-badge.svg" alt="Get it on Google Play" width="151"
            height="46"></a>
          </div>
          <div class="app-promo-qr-img2">
            <a (click)="openAppleAppStore()" class="cursor-pointer"><img src="../../../assets/icons/wir-apple-play-qr.svg" alt="Apple store QR Code for downloading IDP live APP" width="160"
            height="161"></a>
            <a (click)="openAppleAppStore()" class="cursor-pointer"><img src="../../../assets/icons/wir-apple-play-badge.svg" alt="Download on the App Store" width="135"
            height="46"></a>
          </div>
        </div>
        <div class="app-promo-qr-txt">
          <div class="app-promo-qr-txt-para">{{thankYouContentPage.promoDescription}}</div>
        </div>
      </div>
    </div>
  </div>
</div>